// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"picture_imageWrapper__x7xCa","img":"picture_img__3ah3U","checkCircle":"picture_checkCircle__t4p4I","imgSelected":"picture_imgSelected__2l1Fn"};